import { DayMode } from '../../domain/routine/enums';

export const MODES: readonly DayMode[] = [
  DayMode.normal,
  DayMode.busy,
  DayMode.travel,
  DayMode.recovery,
  DayMode.difficult,
  DayMode.elevation,
  DayMode.momentDecisif,
  DayMode.imprevu,
  DayMode.transition,
];

export const MODE_LABELS: Record<DayMode, string> = {
  [DayMode.normal]: 'Normal',
  [DayMode.busy]: 'Chargé',
  [DayMode.travel]: 'Voyage',
  [DayMode.recovery]: 'Récupération',
  [DayMode.difficult]: 'Difficile',
  [DayMode.elevation]: 'Élévation',
  [DayMode.momentDecisif]: 'Moment décisif',
  [DayMode.imprevu]: 'Imprévu',
  [DayMode.transition]: 'Transition',
};

export const MODE_CONSEQUENCES: Record<DayMode, string> = {
  [DayMode.normal]: 'La routine complète reste active, sans restriction.',
  [DayMode.busy]:
    'Seules les missions obligatoires et la mission facultative essentielle compteront dans la progression. Le sport devient une séance courte et le bilan un format raccourci. Rien n’est supprimé : le reste de la routine reste visible.',
  [DayMode.travel]:
    'Les horaires restent souples et le sport devient un mouvement sans équipement. La routine complète reste active.',
  [DayMode.recovery]:
    'Le sport devient une récupération active, sans haute intensité. La routine complète reste active.',
  [DayMode.difficult]:
    'Seules l’eau, la respiration, dix minutes de mouvement, une mission essentielle et un bilan court compteront dans la progression. Aucune mission existante n’est supprimée.',
  [DayMode.elevation]:
    'La routine complète reste active, à l’exigence maximale : s’élever consiste à approfondir le geste, pas à multiplier les gestes.',
  [DayMode.momentDecisif]:
    'Seules les missions obligatoires et la mission facultative essentielle compteront dans la progression. Tout ce qui n’est pas la décision peut attendre.',
  [DayMode.imprevu]:
    'Seules les missions obligatoires et la mission facultative essentielle compteront dans la progression. La journée a changé de forme ; l’essentiel est gardé.',
  [DayMode.transition]:
    'La routine complète reste active, à exigence basse. Entre deux régimes, la continuité prime sur la maîtrise immédiate.',
};
